import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import Logo from '../Images/logo.png'

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Reusable active style handler
  const navLinkClass = ({ isActive }) =>
    isActive ? "nav-link active" : "nav-link";

  return (
    <header className="navbar wow animate__animated animate__fadeInDown">
      {/* Logo */}
      <div className="logo">
        <NavLink to="/" onClick={closeMenu}>
          <img src={Logo} alt="logo" />
        </NavLink>
      </div>

      {/* Desktop Menu */}
      <nav className="nav-links">
        <NavLink to="/" end className={navLinkClass}>
          Home
        </NavLink>
        <NavLink to="/about" className={navLinkClass}>
          About Us
        </NavLink>
        <NavLink to="/services" className={navLinkClass}>
          Products & Services
        </NavLink>
      </nav>

      {/* Right Section */}
      <div className="nav-right">
        <NavLink to="/contact" className="contact-btn">
          Contact us
        </NavLink>
        <button
          className="menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="mobile-menu">
          <NavLink to="/" end className={navLinkClass} onClick={closeMenu}>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass} onClick={closeMenu}>
            About Us
          </NavLink>
          <NavLink to="/services" className={navLinkClass} onClick={closeMenu}>
            Services
          </NavLink>
          <NavLink to="/contact" className="mobile-contact" onClick={closeMenu}>
            Contact us
          </NavLink>
        </div>
      )}
    </header>
  );
};

export default Navbar;